import type { TechniqueDefinition } from "./TechniqueDefinition.js";

export const quedaDoTrovao: TechniqueDefinition = {
  id: "queda_do_trovao",
  name: "Queda do Trovão",
  description:
    "Marks an area, then strikes it with lightning after a short warning.",
  family: "elemental_ninjutsu",
  proficiency: "ninjutsu",
  targeting: "point_area",
  behavior: { kind: "damage" },
  levels: {
    1: {
      chakraCost: 28,
      cooldownMs: 10_000,
      impactDelayMs: 1_200,
      range: 230,
      maxTargets: 5,
      power: 16,
      attackCoefficient: 1.15,
      radius: 72,
    },
    2: {
      chakraCost: 29,
      cooldownMs: 10_000,
      impactDelayMs: 1_200,
      range: 230,
      maxTargets: 5,
      power: 17,
      attackCoefficient: 1.19,
      radius: 74,
    },
    3: {
      chakraCost: 30,
      cooldownMs: 10_000,
      impactDelayMs: 1_200,
      range: 230,
      maxTargets: 5,
      power: 19,
      attackCoefficient: 1.24,
      radius: 76,
    },
    4: {
      chakraCost: 31,
      cooldownMs: 10_000,
      impactDelayMs: 1_200,
      range: 230,
      maxTargets: 5,
      power: 20,
      attackCoefficient: 1.28,
      radius: 78,
    },
    5: {
      chakraCost: 32,
      cooldownMs: 10_000,
      impactDelayMs: 1_200,
      range: 230,
      maxTargets: 5,
      power: 22,
      attackCoefficient: 1.33,
      radius: 80,
    },
    6: {
      chakraCost: 33,
      cooldownMs: 10_000,
      impactDelayMs: 1_200,
      range: 230,
      maxTargets: 5,
      power: 23,
      attackCoefficient: 1.37,
      radius: 82,
    },
    7: {
      chakraCost: 34,
      cooldownMs: 10_000,
      impactDelayMs: 1_200,
      range: 230,
      maxTargets: 5,
      power: 25,
      attackCoefficient: 1.42,
      radius: 84,
    },
    8: {
      chakraCost: 35,
      cooldownMs: 10_000,
      impactDelayMs: 1_200,
      range: 230,
      maxTargets: 5,
      power: 26,
      attackCoefficient: 1.46,
      radius: 85,
    },
    9: {
      chakraCost: 36,
      cooldownMs: 10_000,
      impactDelayMs: 1_200,
      range: 230,
      maxTargets: 5,
      power: 27,
      attackCoefficient: 1.51,
      radius: 87,
    },
    10: {
      chakraCost: 37,
      cooldownMs: 10_000,
      impactDelayMs: 1_200,
      range: 230,
      maxTargets: 5,
      power: 28,
      attackCoefficient: 1.55,
      radius: 88,
    },
  },
  visual: {
    effectId: 37,
    castEffectId: null,
    areaImpactEffectId: 37,
    impactEffectId: null,
  },
};
